import { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box/Box';
import ChildHeader from '../../../components/ui/ChildHeader';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import TController from './components/TController';

const CreateToolHistory = () => {
  const [moduleData, setModuleData] = useState<any>({});
  const { id } = useParams();
  const isView = useQuery('isView') === 'true' ? true : false;

  const calculateCumulative = (moduleData: any) => {
    const values = { ...moduleData };
    let temp = 0;
    let found = false;
    values?.list?.length > 0 &&
      values.list.forEach((item: any) => {
        item.status = '';
        if (!found) values.maintenance_done = 'completed';
        temp += item.actual_prod;
        item.comulative = temp;

        if (temp >= values.changed_frequncy) {
          temp = 0;
          found = true;
          values.maintenance_done = 'start';
          item.status = 'RED (R)';
        }
      });

    setModuleData(values);
  };

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/masterListOfToolNewICPLRoute/${id}`)
        .then((res) => {
          const data = res?.data;
          setModuleData(data);
          calculateCumulative(data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  const [DialogSubmit, confirmSubmit] = useConfirm(
    'Submit',
    'Are you sure you want to save this document?',
  );

  const onSubmit = async () => {
    const ans = await confirmSubmit();
    if (!ans) return;
    await axios
      .put(`/api/masterListOfToolNewICPLRoute/${id}`, moduleData)
      .then((res) => {
        if (res.data) {
          alert('Updated Successfully');
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Box>
        <ChildHeader text="HISTORY-CARD FOR TOOLINGS">
          {!isView && (
            <SubmitButton label="Submit" onClick={() => onSubmit()} />
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          moduleData,
          isView,
          calculateCumulative,
        }}
      />
      <DialogSubmit />
    </>
  );
};

export default CreateToolHistory;
